module.exports = __webpack_public_path__ + "4fd93e7d9adef3658017c3174462e49f.ttf";